/*
 * @Author: chenqing
 * @Date: 2023-03-21 11:18:14
 * @LastEditors: chenqing
 * @LastEditTime: 2023-03-21 16:58:06
 * @FilePath: /chaojimaHome/App/assets/scripts/modules/clearCache/index.js
 * @Description:
 */
$(() => {
  $("#clearCache").on("click", () => {
    $.post($.api.common.clearCache, {}, () => {
      // alert('清除缓存操作成功');
      toastr.success("清除缓存操作成功");
    });
  });
});
